import createVueApp from '@phoenix/createVueApp';

import { PhxsgSlide, PhxsgSlider } from '../Slider';

import PhxsgProgressSlider from './phxsg-progress-slider.vue';

document.querySelectorAll('[data-component="phxsg-progress-slider"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgSlider', PhxsgSlider);
  app.component('PhxsgSlide', PhxsgSlide);
  app.component('PhxsgProgressSlider', PhxsgProgressSlider);
  app.mount(el);
});
